<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="36" height="24" viewBox="0 0 36 24">
    <g class='g'  fill-rule="evenodd">
        <path d="M13.686 15.76l2.048-6.525h1.828l-2.049 6.525zM12.869 9.237l-1.644 2.766c-.419.724-.664 1.09-.781 1.548h-.025c.029-.58-.055-1.293-.063-1.696l-.181-2.618H7.098l-.032.175c.79 0 1.26.384 1.389 1.168l.6 5.18h1.893l3.828-6.523H12.87zM27.082 15.76l-.05-.97-2.283-.002-.467.972h-1.984l3.598-6.513h2.436l.609 6.513h-1.86zm-.21-3.849c-.02-.482-.037-1.137-.003-1.533h-.027c-.111.324-.59 1.297-.8 1.775l-.68 1.43h1.603l-.093-1.672zM19.48 15.946a5.242 5.242 0 0 1-2.758-.748l.871-1.285c.549.297.98.639 1.971.639.319 0 .626-.08.8-.372.255-.425-.058-.653-.772-1.043l-.352-.222c-1.059-.699-1.517-1.362-1.018-2.52.318-.742 1.16-1.303 2.546-1.303.957 0 1.854.4 2.377.79l-1.001 1.134c-.51-.398-.933-.6-1.417-.6-.386 0-.678.144-.78.338-.19.364.062.613.618.946l.42.258c1.284.783 1.59 1.604 1.268 2.371-.554 1.322-1.638 1.617-2.773 1.617z"/>
    </g>
</svg>

</template>

<style lang="scss" scoped>
@use "@/styles/base.scss" as *;

.g {
    @include light-theme((
        fill: #1d5b99
    ));

    @include dark-theme((
        fill: white
    ));
}
</style>